import { useEffect } from 'react';

/**
 * Every link that leaves the site (another domain) always opens in a new tab — even if it's missing
 * target="_blank", or something on the page (smooth scroll, Pixel's click handlers) would otherwise
 * swallow the default navigation. Mail links and on-site links are left alone.
 */
export function useExternalLinksNewTab() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.button !== 0) return;
      const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!a) return;
      // The click that ends a quest drag (dragging a project aside to find a shard) isn't a real click
      // …and neither is picking up a shard hidden behind a linked project (the shard sits inside the link)
      if (a.closest('[data-quest-dragging]') || (e.target as Element).closest('[data-quest-shard]')) {
        e.preventDefault();
        return;
      }
      let url: URL;
      try {
        url = new URL(a.href, window.location.href);
      } catch {
        return;
      }
      if (!/^https?:$/.test(url.protocol) || url.origin === window.location.origin) return;
      e.preventDefault();
      window.open(url.href, '_blank', 'noopener,noreferrer');
    };
    // Capture phase: runs before anything else can intercept the click
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
}
